import styled from 'styled-components';
import tw, { classnames, borderColor, borderRadius, boxShadow, margin, padding, display, width, backgroundColor, transitionProperty, textColor, fontSize } from 'tailwindcss-classnames';

const classBase = classnames(borderColor('border-gray-300', 'focus:border-gray-400', 'focus:border-gray-100'), borderRadius('rounded-md'), boxShadow('shadow-sm', 'focus:shadow-md'), margin('my-2'), padding('px-4', 'py-2'), display('block', 'inline-block'), width('w-full'), backgroundColor('bg-gray-50'), transitionProperty('transition-shadow'));

export const Input = styled.textarea.attrs({
    className: classnames(classBase)
})`
    border: 1px solid;
`

// export const InputError = styled.textarea.attrs({
//     className: classnames(classBase, borderColor('border-red-200'))
// })`
//     border: 2px solid;
// `

export const SpanError = styled.span.attrs({
    className: classnames(textColor('text-red-400'), fontSize('text-sm'))
})``;